import { render, staticRenderFns } from "./NWSLive.vue?vue&type=template&id=31c4bb0b&"
import script from "./NWSLive.vue?vue&type=script&lang=js&"
export * from "./NWSLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports